import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderFilterEntity } from '../../domain/entities/OrderFilterEntity'

export class OrderFilterModel extends OrderFilterEntity {
  userId?: string
  itemId?: number
  branchId?: number
  brandId?: number
  fromDate?: string
  toDate?: string
  minSubTotalPrice?: number
  maxSubTotalPrice?: number
  channelId?: number
  regionIds?: number
  constructor(dataDto: OrderFilterEntity) {
    super()
    mapEntityProperties<OrderFilterModel>(this, dataDto, {
      exclude: ['branch', 'user', 'item', 'brand', 'price', 'channel'],
      map: {
        userId: dataDto.user?.id,
        itemId: dataDto.item?.id,
        branchId: dataDto.branch?.id,
        brandId: dataDto.brand?.id,
        fromDate: dataDto.startDate,
        toDate: dataDto.endDate,
        minSubTotalPrice: dataDto.price ? dataDto.price[0] : undefined,
        maxSubTotalPrice: dataDto.price ? dataDto.price[1] : undefined,
        channelId: dataDto.channel?.id,
        regionIds: dataDto.regions?.map((region) => region.id)
      }
    })
  }
}
